import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ReportOPEEnum} from "./ReportOPEEnum";
import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

class MetricInstanceDTO {
  id!: number;
  name!: string;
  type!: string;
  partitionId!: number;
  partitionName!: string;
  deviceId?: number;
  deviceName?: string;
}

class UserMetricDTO {
  uniqueCode!: string;
  metricInstance!: MetricInstanceDTO;
  functionType!: AggregateFunctionTypeEnum;
}

class UserReportListDTO {
  id!: number;
  name!: string;
  unixCronExpression!: string;
  enabled!: boolean;
  email!: string;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  metrics!: UserMetricDTO[];
}

class O {
  reports!: UserReportListDTO[];
}

class I {
}

export class GetUserReportsCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(ReportOPEEnum.GetUserReports);
    this.i = new I();
    this.o = new O();
  }
}
